import { useAuth } from "@/context/AuthContext";

export const ROLE_LEVELS = { admin: 4, compliance_officer: 3, control_owner: 2, viewer: 1 };

export const hasRole = (role, required) =>
  (ROLE_LEVELS[role] || 0) >= (ROLE_LEVELS[required] || 99);

export const useRole = () => {
  const auth = useAuth();
  return auth?.user?.role || "viewer";
};

export const RoleGuard = ({ requiredRole, children, fallback = null }) => {
  const role = useRole();
  return hasRole(role, requiredRole) ? children : fallback;
};
